import {
    GET_REVENUE_FROM_CUSTOMER_LOADING,
    GET_REVENUE_FROM_CUSTOMER_SUCCESS

} from '../actions/RevenueFromCustomerAction';

const initialState = {
    amazon: {
        revenueFromCustomerData: null,
        isLoading: true,
    },
    shopify: {
        revenueFromCustomerData: null,
        isLoading: true,
    },
    wholesale: {
        revenueFromCustomerData: null,
        isLoading: true,
    }
};

const RevenueFromCustomerReducer = (state = initialState, action = {}) => {
    switch (action.type) {
        case GET_REVENUE_FROM_CUSTOMER_SUCCESS:
            return {
                ...state, [action.vendor]: { revenueFromCustomerData: action.data, isLoading: false }
            };

        case GET_REVENUE_FROM_CUSTOMER_LOADING:
            return { ...state, [action.vendor]: { ...state?.[action.vendor], isLoading: action.isLoading } };

        default:
            return state;
    }
};

export default RevenueFromCustomerReducer;
